
function addToCartSticky() {
  const addToCartButton = document.querySelector('.add-to-cart-sticky');
  const originalButton = document.querySelector('.add-to-cart-sticky-ref');

  if (!addToCartButton || !originalButton) return;

  addToCartButton.addEventListener('click', () => {
    originalButton.click();
  });
}

function changeDetails() {
  const radios = document.querySelector('.rc-widget');
  const priceSticky = document.querySelectorAll('.price-sticky');

  if (radios) {
    const radiochecked = radios.querySelector('input[type="radio"]:checked+.rc-radio__label');
    const price = radiochecked.querySelector('.price-label').innerText;

    priceSticky.forEach((el) => {
      el.textContent = price;
    });

  }

}
document.addEventListener('DOMContentLoaded', function() {

  let intersectionObserver;

  addToCartSticky();
  // Check if viewport width is mobile
  const isMobile = () => window.innerWidth <= 768;

  const originalButton = document.querySelector('.add-to-cart-sticky-ref');
  const stickyBar = document.querySelector('.sticky-main');

  if (!originalButton || !stickyBar) return;

  const options = {
    root: null,
    rootMargin: '-80px 0px 800px 0px', 
    threshold: 0
  };

  // Initialize intersection observer
  intersectionObserver = new IntersectionObserver(async (entries) => {

    const showChat = document.querySelector('#chat-button');
    if (entries[0].intersectionRatio <= 0 && isMobile()) {
      stickyBar.style.display = 'block';
      changeDetails();
      return
    };
    stickyBar.style.display = 'none'
  }, options );

intersectionObserver.observe(originalButton);

  // Handle window resize
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      stickyBar.style.display = 'none';
    }
  });
});